<template>
  <v-navigation-drawer
    app
    floating
    v-model="drawerModel"
    clipped
    v-if="usuarioLogado"
  >
    <UsuarioLogado />
    <v-divider></v-divider>

    <v-list v-if="menus.length > 0" two-line>
      <div v-for="(menu, i) in menus" :key="i">
        <template v-if="menu.submenus.length == 0">
          <v-list-item
            link
            :to="{ path: menu.link }"
            active-class="colormenuselect font-weight-bold"
            style="min-height: 56px"
          >
            <v-list-item-action>
              <v-icon size="25" color="primary">{{ menu.icone }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="primary--text subtitle-1">{{
                menu.descricao
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-group>
            <template v-slot:activator>
              <v-list-item-action>
                <v-icon size="25" color="primary">{{ menu.icone }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="primary--text subtitle-1">{{
                  menu.descricao
                }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(item, i) in menu.submenus"
              :key="i"
              link
              :to="{ path: item.link }"
              active-class="font-weight-bold"
              style="min-height: 50px !important"
            >
              <v-list-item-action> </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="primary--text wrap-text subtitle-2">{{
                  item.descricao
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import UsuarioLogado from "../components/usuario/UsuarioLogado.vue";
import { mapMutations, mapState } from "vuex";
export default {
  name: "MenuTemplate",
  components: {
    UsuarioLogado,
  },
  computed: {
    ...mapState("sistema", ["drawer"]),
    ...mapState("usuario", ["usuarioLogado"]),
    drawerModel: {
      get: function () {
        return this.drawer;
      },
      set: function (value) {
        this.setDrawer(value);
      },
    },
  },
  data: () => ({
    menus: [
      {
        descricao: "Cadastros",
        icone: "mdi-account-multiple-plus-outline",
        submenus: [{ descricao: "Clientes", link: "/clientes" }],
      },
      {
        descricao: "Pedidos",
        icone: "mdi-cart-arrow-down",
        submenus: [
          { descricao: "Central de pedidos", link: "/selecionar-tipo-pedido/pedidos" },
          { descricao: "Emissão de pedidos", link: "/selecionar-tipo-pedido/emissao" },
        ],
      },
      {
        descricao: "Relatórios",
        icone: "mdi-chart-line",
        link: "/relatorios",
        submenus: [],
      },
    ],
  }),
  methods: {
    ...mapMutations("sistema", ["setDrawer"]),
  },
};
</script>

<style>
.v-list--two-line .v-list-item,
.v-list-item--two-line {
  min-height: 58px;
}
</style>